import { cn } from '@/shared/utils/cn';
import { VisualSlotType } from '@/shared/types/types';
import React from 'react';
import { ListItemDefault } from '../molecules/ListItemDefault';
import { ListSeparator } from '../molecules/ListSeparator';

export interface ListWithSeparatorGroup {
  items: Array<{
    id: string;
    label: string;
    icon?: VisualSlotType;
    disabled?: boolean;
  }>;
}

export interface ListWithSeparatorProps {
  groups: ListWithSeparatorGroup[];
  currentValue?: string;
  onItemClick?: (itemId: string) => void;
  className?: string;
}

export const ListWithSeparator: React.FC<ListWithSeparatorProps> = ({
  groups,
  currentValue,
  onItemClick,
  className,
}) => {
  return (
    <div
      className={cn(
        'ui-rounded-surface-card ui-border ui-border-default ui-bg-fill ui-p-8 ui-shadow-03',
        'ui-min-w-[208px]',
        className,
      )}
    >
      <ul className="ui-m-0 ui-flex ui-list-none ui-flex-col ui-gap-8 ui-p-0">
        {groups.map((group, groupIndex) => (
          <React.Fragment key={groupIndex}>
            {groupIndex > 0 && <ListSeparator />}
            {group.items.map((item) => (
              <ListItemDefault
                key={item.id}
                icon={item.icon}
                disabled={item.disabled}
                current={currentValue === item.id}
                onClick={() => onItemClick?.(item.id)}
              >
                {item.label}
              </ListItemDefault>
            ))}
          </React.Fragment>
        ))}
      </ul>
    </div>
  );
};
